<div class="d-flex h-100">
  <div
    class="threeds-dialog col-sm-6 p-6 m-auto write-review-dialog d-flex flex-column"
    (click)="$event.stopPropagation()">
    <udex-control-button
      [tabindex]="0"
      dcpAutofocus
      (click)="sendCancelMessage()"
      icon="decline"
      size="Small"
      accessible-role="Button">
    </udex-control-button>
    <iframe
      #stepUpIframe
      id="step_up_iframe"
      style="border: none; margin-left: auto; margin-right: auto; display: block"
      height="740px"
      width="400px"
      name="stepUpIframe">
    </iframe>
    <form
      id="step_up_form"
      #stepUpForm
      ngNoForm
      name="stepUpForm"
      method="POST"
      target="stepUpIframe"
      [action]="authEnrollmentData?.stepUpUrl">
      <input
        #stepUpInput
        id="step_up_form_jwt_input"
        type="hidden"
        name="JWT"
        [value]="authEnrollmentData?.accessToken" />
      <input id="step_up_form_md_input" type="hidden" name="MD" [value]="body" />
    </form>
  </div>
</div>
